import { render, staticRenderFns } from "./TouchpointInfoConnectionListRow.vue?vue&type=template&id=154f03b8&scoped=true&"
import script from "./TouchpointInfoConnectionListRow.vue?vue&type=script&lang=js&"
export * from "./TouchpointInfoConnectionListRow.vue?vue&type=script&lang=js&"
import style0 from "./TouchpointInfoConnectionListRow.vue?vue&type=style&index=0&id=154f03b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154f03b8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\marketingdatabase-git\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('154f03b8')) {
      api.createRecord('154f03b8', component.options)
    } else {
      api.reload('154f03b8', component.options)
    }
    module.hot.accept("./TouchpointInfoConnectionListRow.vue?vue&type=template&id=154f03b8&scoped=true&", function () {
      api.rerender('154f03b8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/CanvasArea/Bricks/TouchpointOverview/TouchpointInfoConnectionListRow.vue"
export default component.exports